<template>
  <div class="MissionArchiveDetails">
    <v-dialog v-model="visible">
      <box :title="$t('extraWorkDetails')">
        <v-row class="pa-2">
          <v-col cols="6">
            <v-row>
              <v-col>{{ $t("PageNo") }}:</v-col>
              <v-col>
                <span class="text-value">{{ item.PAGENO }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="6">
            <v-row>
              <v-col>{{ $t("RequestedPersonName") }}:</v-col>
              <v-col>
                <span class="text-value">{{ item.personName }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="6">
            <v-row>
              <v-col>{{ $t("BeginDate") }}:</v-col>
              <v-col>
                <span class="text-value">{{ item.BEGINDATE }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="6">
            <v-row>
              <v-col>{{ $t("BeginTime") }}:</v-col>
              <v-col>
                <span class="text-value">{{ item.BEGINTIME }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="6">
            <v-row>
              <v-col>{{ $t("EndDate") }}:</v-col>
              <v-col>
                <span class="text-value">{{ item.ENDDATE }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="6">
            <v-row>
              <v-col>{{ $t("EndTime") }}:</v-col>
              <v-col>
                <span class="text-value">{{ item.ENDTIME }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="6">
            <v-row>
              <v-col>{{ $t("requestType") }}:</v-col>
              <v-col>
                <span class="text-value">{{
                  item.isGroup ? $t("groupRequest") : $t("oneRequest")
                }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="6">
            <v-row>
              <v-col>{{ $t("LastChangeDate") }}:</v-col>
              <v-col>
                <span class="text-value">{{ item.lastChangeDate }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12">
            <v-row>
              <v-col cols="3">{{ $t("status") }}:</v-col>
              <v-col cols="9">
                <span
                  class="text-value"
                  v-text="
                    item.Statustype +
                    '-' +
                    (details.IsTransfer
                      ? 'انتقال داده شده'
                      : 'انتقال داده نشده')
                  "
                ></span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12">
            <v-row>
              <v-col cols="3">{{ $t("description") }}:</v-col>
              <v-col cols="9">
                <span class="text-value">
                  {{ item.personName }}:{{ details.userDescription }} <br />
                  <span
                    >تائید / رد کننده: {{ ApprovedPerson }}
                    {{ details.adminDescription }}</span
                  >
                </span>
              </v-col>
            </v-row>
          </v-col>

          <v-col v-if="details.personelsName" cols="12">
            {{ $t("personelsName") }}:

            <span class="text-value"> {{ details.personelsName }} <br /> </span>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn small v-if="visibleReturn" @click="ReturnRequest">{{
            $t("ReturnRequest")
          }}</v-btn>
          <v-btn small v-if="visibleReject" @click="RejectRequest">{{
            $t("RejectRequest")
          }}</v-btn>
          <v-btn small v-if="visibleApprove" @click="ApproveRequest">{{
            $t("ApproveRequest")
          }}</v-btn>
          <v-btn small v-if="visibleDelete" @click="DeleteRequest">{{
            $t("DeleteRequest")
          }}</v-btn>
          <v-btn small v-if="visibleEdit" @click="EditRequest">{{
            $t("EditRequest")
          }}</v-btn>
        </v-card-actions>

        <archive-detals-flow
          :pageNo="item.PAGENO + ''"
          :pageType="4"
          :year="Number(item.Year)"
        />
      </box>
    </v-dialog>
  </div>
</template>

<script>
import RequestState from "@/model/RequestState";
import ArchiveDetalsFlow from "../../request/ArchiveDetalsFlow.vue";
import TextUtils from "../../../utils/TextUtils";
import EosUtils from "../../../utils/EosUtils";
import ResultType from "../../../model/ResultType";

const initialData = () => {
  return {
    visible: false,
    item: "",
    details: "",
    visibleEdit: false,
    visibleDelete: false,
    visibleReject: false,
    visibleReturn: false,
    visibleApprove: false,
    ApprovedPerson: "",
  };
};

export default {
  components: { ArchiveDetalsFlow },
  props: {},
  data() {
    return initialData();
  },
  methods: {
    resetData() {
      Object.assign(this.$data, initialData());
    },
    show(item) {
      this.resetData();
      this.visible = true;
      this.item = item;
      this.GetExtraWorkDetail(item);
    },
    hide() {
      this.visible = false;
    },
    GetExtraWorkDetail(item) {
      //console.log(item);
      const params = new URLSearchParams();
      params.append("pageno", TextUtils.convertToEnglishDigits(item.PAGENO));
      params.append("dbkind", "1");
      params.append("year", item.Year);
      params.append("perno", TextUtils.convertToEnglishDigits(item.perno));
      params.append("isGetForEdit", false);

      this.$store.dispatch("GetExtraWorkDetail", { params }).then((result) => {
        //console.log(result);
        if (result.type == "success") {
          if (result.data.Table.length > 0) {
            this.details = result.data.Table[0];
            this.checkActionsVisiblity();
            this.getApprovedPerson();
          }
        }
      });
    },
    getApprovedPerson() {
      if (this.details.approvedBy.trim() == "-1") {
        this.ApprovedPerson = this.$t("webkartManager");
      } else if (this.details.approvedBy.trim() == "000") {
        this.ApprovedPerson = this.$t("winkartManager");
      } else {
        let params = new URLSearchParams();
        params.append("perno", this.details.approvedBy.trim());
        this.$store.dispatch("GetPersonFullName", { params }).then((result) => {
          if (result.type === ResultType.success) {
            this.ApprovedPerson = result.data;
          }
        });
      }
    },
    checkActionsVisiblity() {
      var params = new URLSearchParams();
      params.append(
        "pagePerno",
        TextUtils.convertToEnglishDigits(this.item.PAGENO.toString().trim())
      );
      params.append(
        "section",
        TextUtils.convertToEnglishDigits(this.item.section.trim())
      );
      params.append("status", this.item.status);
      this.$store
        .dispatch("GetExtraWorkDetailForAdmin", { params })
        .then((result) => {
          if (result.type === ResultType.success) {
            this.visibleEdit = result.data.Edit;
            this.visibleDelete = result.data.Delete;
            this.visibleReject = result.data.Reject;
            this.visibleReturn = result.data.Return;
            this.visibleApprove = result.data.Approve;
          }
        });
    },
    EditRequest() {
      this.hide();
      //console.log(this.details);
      //console.log(this.item);

      var Details = {
        Year: this.item.Year,
        PageNo: TextUtils.convertToEnglishDigits(
          this.item.PAGENO.toString().trim()
        ),
        //Type: this.details.Type,
        DBKind: 1,
        selectedPerno: TextUtils.convertToEnglishDigits(
          this.item.perno.toString().trim()
        ),
      };

      if (EosUtils.isWebKartAdmin()) {
        Details.from = "admin-extra-work-management";
        this.$router.push({
          name: "admin-request-extra-work",
          params: { details: Details },
        });
      }
    },
    DeleteRequest() {
      this.operationOnRequest(RequestState.RequestState.Delete);
    },
    ReturnRequest() {
      this.operationOnRequest(RequestState.RequestState.Return);
    },
    RejectRequest() {
      this.operationOnRequest(RequestState.RequestState.Reject);
    },
    ApproveRequest() {
      this.operationOnRequest(RequestState.RequestState.Approve);
    },
    operationOnRequest(requestState) {
      var list = [this.item];
      this.$emit("operationOnRequest", requestState, list);
      this.hide();
    },
  },
};
</script>

<style scoped>
*td {
  padding: 2px;
}
</style>